import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { SVG_List } from '../constants/svg-constants';

@Injectable({
  providedIn: 'root'
})
export class IconServiceService {

  iconObj = SVG_List;
  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) { }

  public registerIcons(): void {
    this.loadIconConstants();
  }

  private loadIconConstants() {
    this.iconObj.forEach(item => {
      this.matIconRegistry.addSvgIconLiteral(item.name, this.domSanitizer.bypassSecurityTrustHtml(item.svg));
    })
  }

}
